import { createTheme } from "@mui/material/styles";
import { frFR } from "@mui/material/locale";
import { getBrandConfig } from "../config/brandConfig";

const fontFamily = getBrandConfig().fontFamily
// Thème centralisé avec Crimson Pro
export const customTheme = createTheme(
  {
    typography: {
      fontFamily: fontFamily,
      h1: {
        fontFamily: fontFamily,
        fontWeight: 700,
      },
      h2: {
        fontFamily: fontFamily,
        fontWeight: 700,
      },
      h3: {
        fontFamily: fontFamily,
        fontWeight: 700,
      },
      h4: {
        fontFamily: fontFamily,
        fontWeight: 600,
      },
      h5: {
        fontFamily: fontFamily,
        fontWeight: 600,
      },
      h6: {
        fontFamily: fontFamily,
        fontWeight: 600,
      },
      subtitle1: {
        fontFamily: fontFamily,
        fontWeight: 500,
      },
      subtitle2: {
        fontFamily: fontFamily,
        fontWeight: 500,
      },
      body1: {
        fontFamily: fontFamily,
        fontWeight: 400,
      },
      body2: {
        fontFamily: fontFamily,
        fontWeight: 400,
      },
      button: {
        fontFamily: fontFamily,
        fontWeight: 600,
        textTransform: "none",
      },
      caption: {
        fontFamily: fontFamily,
        fontWeight: 400,
      },
      overline: {
        fontFamily: fontFamily,
        fontWeight: 500,
      },
    },
    // colorSchemes: {
    //   light: {
    //     palette: {
    //       mode: "light",
    //       primary: {
    //         main: "#1976D2",
    //       },
    //       secondary: {
    //         main: "#F4FAFF",
    //       },
    //     },
    //   },
    // },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontFamily: fontFamily,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: fontFamily,
            fontWeight: 600,
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-root": {
              fontFamily: fontFamily,
            },
            "& .MuiInputLabel-root": {
              fontFamily: fontFamily,
            },
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            fontFamily: fontFamily,
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            fontFamily: fontFamily,
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontFamily: fontFamily,
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            fontFamily: fontFamily,
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            fontFamily: fontFamily,
          },
        },
      },
      MuiStep: {
        styleOverrides: {
          root: {
            fontFamily: fontFamily,
          },
        },
      },
      MuiStepLabel: {
        styleOverrides: {
          label: {
            fontFamily: fontFamily,
          },
        },
      },
    },
  },
  frFR
);

